import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';

export default function Projectos() {
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const categories = [
    { id: 'todos', label: 'TODOS OS PROJECTOS' },
    { id: 'sustentabilidade', label: 'SUSTENTABILIDADE' },
    { id: 'consultoria', label: 'CONSULTORIA' },
    { id: 'formacao', label: 'FORMAÇÃO' },
    { id: 'eventos', label: 'EVENTOS' },
  ];

  const projects = [
    {
      id: 1,
      category: 'sustentabilidade',
      title: 'Programa de Gestão Ambiental Corporativa',
      client: 'Empresa Líder em Energia',
      description: 'Desenvolvimento e implementação de um programa integrado de gestão ambiental, com foco na eficiência operacional, conformidade regulatória e redução de impactos ambientais, alinhado às melhores práticas internacionais',
      image: 'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/e408fc919a9f96219284175edc0de09f.webp',
      results: ['Melhoria dos processos ambientais', 'Redução de riscos operacionais', 'Fortalecimento da cultura de sustentabilidade'],
      year: '2024',
    },
    {
      id: 2,
      category: 'consultoria',
      title: 'Reestruturação Estratégica Organizacional',
      client: 'Grupo Empresarial Multisectorial',
      description: 'Apoio à reestruturação estratégica de processos organizacionais, com vista ao aumento da eficiência, melhoria da governação interna e alinhamento com os objectivos institucionais.',
      image: 'https://readdy.ai/api/search-image?query=african%20business%20executives%20strategic%20planning%20meeting%20organizational%20restructuring%20corporate%20boardroom%20modern%20office%20professional%20team%20collaboration%20charts%20graphs%20data%20analysis%20Angola%20Africa%20business%20transformation%20leadership&width=800&height=600&seq=kudima-project-consult-002&orientation=landscape',
      results: ['Optimização de processos', 'Melhoria da tomada de decisão', 'Aumento da eficiência organizacional'],
      year: '2024',
    },
    {
      id: 3,
      category: 'formacao',
      title: 'Programa de Capacitação em Liderança Sustentável',
      client: 'Instituição Financeira Nacional',
      description: 'Desenvolvimento e execução de programa de formação executiva focado em liderança sustentável e gestão de mudanças para 150 gestores.',
      image: 'https://readdy.ai/api/search-image?query=african%20business%20professionals%20leadership%20training%20workshop%20corporate%20education%20sustainable%20management%20executive%20development%20modern%20training%20room%20interactive%20learning%20Angola%20Africa%20professional%20development%20team%20building&width=800&height=600&seq=kudima-project-training-003&orientation=landscape',
      results: ['150 gestores capacitados', '95% satisfação', 'Certificação internacional'],
      year: '2023',
    },
    {
      id: 4,
      category: 'sustentabilidade',
      title: 'Relatório de Sustentabilidade Integrado',
      client: 'Corporação Industrial',
      description: 'Elaboração de relatório de sustentabilidade integrado, alinhado aos referenciais ESG e aos Objectivos de Desenvolvimento Sustentável (ODS), assegurando transparência, credibilidade e comunicação eficaz do desempenho institucional.',
      image: 'https://readdy.ai/api/search-image?query=african%20business%20team%20analyzing%20sustainability%20report%20ESG%20metrics%20environmental%20social%20governance%20data%20charts%20corporate%20responsibility%20modern%20office%20professional%20setting%20Angola%20Africa%20sustainable%20business%20practices&width=800&height=600&seq=kudima-project-report-004&orientation=landscape',
      results: ['Estruturação da informação ESG', 'Reforço da reputação institucional', 'Comunicação clara com stakeholders'],
      year: '2023',
    },
    {
      id: 5,
      category: 'eventos',
      title: 'Evento Anual de Sustentabilidade',
      client: 'Associação Empresarial',
      description: 'Planeamento e execução de fórum institucional dedicado à sustentabilidade empresarial, promovendo o diálogo estratégico, partilha de boas práticas e fortalecimento de redes de colaboração.',
      image: 'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/02a16d9cd0e4e6f71e0d092732a0d552.jpeg',
      results: ['Envolvimento de stakeholders', 'Visibilidade institucional', 'Promoção de parcerias estratégicas'],
      year: '2024',
    },
    {
      id: 6,
      category: 'consultoria',
      title: 'Diagnóstico e Plano de Transformação Digital',
      client: 'Empresa de SERVIÇOS',
      description: 'Realização de diagnóstico organizacional e desenvolvimento de um plano estratégico de transformação digital, visando a modernização de processos, melhoria da eficiência e suporte à tomada de decisão baseada em dados.',
      image: 'https://readdy.ai/api/search-image?query=african%20business%20professionals%20digital%20transformation%20technology%20implementation%20modern%20office%20computers%20data%20analytics%20automation%20corporate%20innovation%20Angola%20Africa%20business%20technology%20digital%20strategy%20team%20collaboration&width=800&height=600&seq=kudima-project-digital-006&orientation=landscape',
      results: ['Modernização de processos internos', 'Aumento da eficiência operacional', 'Suporte à inovação organizacional'],
      year: '2023',
    },
  ];

  const filteredProjects = selectedCategory === 'todos' 
    ? projects 
    : projects.filter(p => p.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#F8F8F8] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <span className="inline-block bg-[#CB9832]/10 text-[#CB9832] px-4 py-2 rounded-full text-sm font-semibold mb-6">
              PORTFÓLIO
            </span>
            <h1 className="text-5xl md:text-5xl font-bold text-[#1A1A1A] mb-6 leading-tight">
              Projectos que Transformam Negócios
              <br />
              e Geram
              <span className="text-[#CB9832]"> Impacto Sustentável</span>
            </h1>
            <p className="text-lg text-[#4A4A4A] leading-relaxed">
              Conheça alguns dos projectos estratégicos desenvolvidos pela +KUDIMA em parceria com instituições públicas e privadas, orientados para resultados concretos, impacto mensurável e criação de valor a longo prazo.
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-[#234A32] text-white shadow-lg'
                    : 'bg-[#F8F8F8] text-[#4A4A4A] hover:bg-[#E8E8E8]'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group cursor-pointer border border-gray-100"
              >
                <div className="relative w-full h-80 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>

                <div className="p-8">
                  <div className="flex items-center gap-2 mb-4">
                    <span className="text-xs font-semibold text-[#234A32] bg-[#234A32]/10 px-3 py-1 rounded-full uppercase">
                      {categories.find(c => c.id === project.category)?.label}
                    </span>
                  </div>

                  <h3 className="text-2xl font-bold text-[#1A1A1A] mb-3 group-hover:text-[#CB9832] transition-colors">
                    {project.title}
                  </h3>

                  <p className="text-[#4A4A4A] leading-relaxed mb-6">
                    {project.description}
                  </p>

                  <div className="border-t border-gray-200 pt-6">
                    <p className="text-sm font-semibold text-[#1A1A1A] mb-3">RESULTADOS ALCANÇADOS:</p>
                    <div className="flex flex-wrap gap-2">
                      {project.results.map((result, index) => (
                        <span
                          key={index}
                          className="inline-flex items-center text-xs bg-[#F8F8F8] text-[#4A4A4A] px-3 py-2 rounded-lg"
                        >
                          <i className="ri-check-line text-[#234A32] mr-1"></i>
                          {result}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-24 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/9b0b37c162d7c8457f9a575c0ef7ab2c.jpeg')`,
          }}
        ></div>
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            PRONTO PARA TRANSFORMAR O SEU NEGÓCIO?
          </h2>
          <a
            href="/contato"
            className="inline-flex items-center bg-[#CB9832] text-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-[#B8862D] transition-all shadow-xl whitespace-nowrap cursor-pointer"
          >
            AGENDAR CONSULTORIA
            <i className="ri-arrow-right-line ml-3 text-lg"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
